'use strict';

var React = require('react');

const initialValue = {};
var WidgetControllerContext = React.createContext(initialValue);

exports.WidgetControllerContext = WidgetControllerContext;
//# sourceMappingURL=WidgetControllerContext-924d4968.js.map
